<template>
  <div class="help-center">
    <!-- <QuestionList></QuestionList> -->
    <router-view />
  </div>
</template>

<script>
import QuestionList from './views/questionList.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'helpCenter',
  components: {
    QuestionList,
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang='less' scoped>
.help-center {
  overflow-x: hidden;
  min-height: 100vh;
  max-height: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/views/helpCenter/helpCenter.vue